export const isMobile = (screenWidth: number): boolean => {
	return screenWidth <= 768;
};

export const vibrate = (pattern: number | number[]) => {
	window.navigator.vibrate && window.navigator.vibrate(pattern);
};
